import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Button,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  IconButton,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import {
  Security as SecurityIcon,
  Science as ScienceIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export const MyDataTab: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        {t('settings.myData.title')}
      </Typography>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Card>
            <CardContent>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <SecurityIcon sx={{ mr: 1 }} color="primary" />
                  <Typography variant="h6">
                    {t('settings.myData.auditLogs.title')}
                  </Typography>
                </Box>
                <Tooltip title={t('settings.myData.auditLogs.futureFeature')} arrow>
                  <IconButton size="small" color="primary">
                    <ScienceIcon />
                  </IconButton>
                </Tooltip>
              </Box>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {t('settings.myData.auditLogs.description')}
              </Typography>
              <Typography variant="caption" color="text.secondary" sx={{ mb: 2 }}>
                {t('settings.myData.auditLogs.details')}
              </Typography>
              <Button
                variant="outlined"
                startIcon={<SecurityIcon />}
                disabled
              >
                {t('settings.myData.auditLogs.button')}
              </Button>
            </CardContent>
          </Card>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Card>
            <CardContent>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {t('settings.myData.privacy.title')}
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {t('settings.myData.privacy.description')}
              </Typography>

              <List dense>
                <ListItem>
                  <ListItemText
                    primary={t('settings.myData.privacy.storedData')}
                    secondary={t('settings.myData.privacy.storedDataDetails')}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('settings.myData.privacy.retentionPeriod')}
                    secondary={t('settings.myData.privacy.retentionPeriodDetails')}
                  />
                </ListItem>
                <ListItem>
                  <ListItemText
                    primary={t('settings.myData.privacy.yourRights')}
                    secondary={t('settings.myData.privacy.yourRightsDetails')}
                  />
                </ListItem>
              </List>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
